import React from "react";
import { CONFIDENCE_META } from "../../lib/constants";
import { cn } from "../../lib/utils";

/**
 * ConfidenceChip — always renders WITH a tooltip that lists the confidence
 * adjustments verbatim. Never render this without a `reasons` array unless
 * the tooltip omission is deliberate.
 */
export function ConfidenceChip({
  level, reasons = [], className, "data-testid": testId,
}) {
  const meta = CONFIDENCE_META[level] || CONFIDENCE_META.CANNOT_DETERMINE;
  return (
    <span
      className="inline-flex items-center gap-2"
      data-testid={testId || `confidence-chip-${(level || "unknown").toLowerCase()}`}
    >
      <span
        className={cn(
          "inline-flex items-center gap-2 rounded px-2 py-0.5 text-xs font-medium",
          meta.bg, meta.text, className,
        )}
        aria-label={`confidence ${meta.label.toLowerCase()}`}
      >
        {meta.label} confidence
      </span>
      <span
        aria-hidden="true"
        className="inline-block h-1.5 w-16 rounded bg-slate-100 overflow-hidden"
      >
        <span
          className="block h-full bg-slate-400"
          style={{ width: `${meta.bar}%` }}
        />
      </span>
      {reasons.length > 0 && (
        <span
          className="text-xs text-slate-500 underline decoration-dotted cursor-help"
          title={reasons
            .map((r) => `${r.rule_id}: ${r.from_level}→${r.to_level} (${r.reason})`)
            .join("\n")}
          data-testid="confidence-chip-why"
        >
          Why?
        </span>
      )}
    </span>
  );
}
